export const LastPageIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L10.5858 12L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L5.70711 4.29289ZM11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289C9.90237 4.68342 9.90237 5.31658 10.2929 5.70711L16.5858 12L10.2929 18.2929C9.90237 18.6834 9.90237 19.3166 10.2929 19.7071C10.6834 20.0976 11.3166 20.0976 11.7071 19.7071L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L11.7071 4.29289Z"
      fill="currentColor"
    />
  </svg>
);
